var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useState } from 'react';
export var DEFAULT_CELL_WIDTH = 100;
export var DEFAULT_CELL_HEIGHT = 22;
export default function useTableCells(widths, heights) {
    if (heights === void 0) { heights = [DEFAULT_CELL_HEIGHT]; }
    var _a = __read(useState(widths), 2), cellWidth = _a[0], setCellWidth = _a[1];
    var _b = __read(useState(heights), 2), cellHeight = _b[0], setCellHeight = _b[1];
    var onCellWidthChange = function (indices, newWidth) {
        var e_1, _a;
        var cw = __spreadArray([], __read(cellWidth), false);
        try {
            for (var indices_1 = __values(indices), indices_1_1 = indices_1.next(); !indices_1_1.done; indices_1_1 = indices_1.next()) {
                var columnIdx = indices_1_1.value;
                if (columnIdx > cw.length) {
                    for (var i = cw.length; i <= columnIdx; i++) {
                        cw.push(DEFAULT_CELL_WIDTH);
                    }
                }
                cw[columnIdx] = newWidth;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (indices_1_1 && !indices_1_1.done && (_a = indices_1.return)) _a.call(indices_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        setCellWidth(cw);
    };
    var onCellHeightChange = function (indices, newHeight) {
        var e_2, _a;
        var ch = __spreadArray([], __read(cellHeight), false);
        try {
            for (var indices_2 = __values(indices), indices_2_1 = indices_2.next(); !indices_2_1.done; indices_2_1 = indices_2.next()) {
                var rowIdx = indices_2_1.value;
                if (rowIdx > ch.length) {
                    for (var i = ch.length; i <= rowIdx; i++) {
                        ch.push(DEFAULT_CELL_HEIGHT);
                    }
                }
                ch[rowIdx] = newHeight;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (indices_2_1 && !indices_2_1.done && (_a = indices_2.return)) _a.call(indices_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        setCellHeight(ch);
    };
    return { onCellWidthChange: onCellWidthChange, onCellHeightChange: onCellHeightChange, setCellWidth: setCellWidth, cellWidth: cellWidth, cellHeight: cellHeight };
}
